type SortableTable = JQuery<HTMLElement> & {
    sortable(options: Record<string, unknown>): JQuery;
};

function initListItemsSortable(
    table: JQuery<HTMLElement>,
    fixHelper: (event: JQuery.Event, ui: JQuery<HTMLElement>) => JQuery<HTMLElement>,
    orderUpdate: () => void,
): void {
    (table as SortableTable).sortable({ helper: fixHelper, update: orderUpdate }).disableSelection();
    table.addClass('sortableActive');
}

export function initSettingsModuleListOrder(root: HTMLElement): void {
    const updateOrderUrl = root.dataset.updateOrderUrl ?? '';

    if (!updateOrderUrl) {
        return;
    }

    const fixHelper = (_event: JQuery.Event, ui: JQuery<HTMLElement>) => {
        ui.children().each(function eachChild() {
            $(this).width($(this).width());
        });

        return ui;
    };

    const orderUpdate = () => {
        const order: string[] = [];

        $('form[id^="frm-listItems"] table tr.row-inner', root).each(function eachRow(_index, row) {
            const rowId = $(row).attr('id') ?? '';
            const itemId = rowId.replace(/snippet-listItems-\d+-rows-/, '');
            order.push(itemId);
        });

        $.nette.ajax({
            data: { order },
            url: updateOrderUrl,
        });
    };

    const initSortableTables = () => {
        const inactiveTable = $('form[id^="frm-listItems"] table tbody', root).filter(':not(.sortableActive)');

        if (inactiveTable.length > 0) {
            initListItemsSortable(inactiveTable, fixHelper, orderUpdate);
        }
    };

    initSortableTables();

    $.nette.ext({
        load() {
            initSortableTables();
        },
    });
}
